import { useMemo, type HTMLAttributes } from 'react';
import styled from 'styled-components';

import { decorateRatingScore, getColor } from '@/app/components/hotel-detail/trust-you/trustyou.helper';

type BadgeProps = {
  $backgroundColor: string;
};

const Badge = styled.span<BadgeProps>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-radius: 8px;
  color: ${({ theme }) => theme.commons.colors.gray0};
  font-weight: ${({ theme }) => theme.commons.font.weights.bold};
  text-align: center;
`;

type TrustYouScoreProps = {
  score: number;
} & HTMLAttributes<HTMLElement>;

export default function TrustYouScore(props: TrustYouScoreProps) {
  const { score, ...rest } = props;
  const color = useMemo((): string => getColor(score), [score]);
  return (
    <Badge $backgroundColor={color} {...rest}>
      {decorateRatingScore(score)}
    </Badge>
  );
}
